/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type FC, type PropsWithChildren } from 'react';

import { I18n } from '@trebox-arch/i18n';
import { Popover } from '@trebox-arch/bot-semi';

import styles from './index.module.less';

export const FilePopover: FC<
  PropsWithChildren<{
    fileNames: string[];
    showTitle?: boolean;
  }>
> = ({ fileNames = [], showTitle = true, children }) => (
  <Popover
    className={styles.popover}
    content={
      <div>
        {showTitle ? <p>{I18n.t('datasets_processing_notice')}</p> : null}
        <p>{fileNames.join('\n')}</p>
      </div>
    }
  >
    {children}
  </Popover>
);
